import v from "../../../../../@vue_babel-helper-vue-jsx-merge-props@1.4.0/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js";
import { inherit as d } from "../utils/functional.js";
import { createNamespace as g } from "../utils/create/index.js";
import { addUnit as u } from "../utils/format/unit.js";
var f = g("loading"),
  y = f[0],
  i = f[1];
function x(t, e) {
  if (e.type === "spinner") {
    for (var r = [], a = 0; a < 12; a++) r.push(t("i"));
    return r;
  }
  return t("svg", {
    class: i("circular"),
    attrs: {
      viewBox: "25 25 50 50"
    }
  }, [t("circle", {
    attrs: {
      cx: "50",
      cy: "50",
      r: "20",
      fill: "none"
    }
  })]);
}
function S(t, e, r) {
  if (r.default) {
    var a,
      n = {
        fontSize: u(e.textSize),
        color: (a = e.textColor) != null ? a : e.color
      };
    return t("span", {
      class: i("text"),
      style: n
    }, [r.default()]);
  }
}
function m(t, e, r, a) {
  var n = e.color,
    c = e.size,
    l = e.type,
    o = {
      color: n
    };
  if (c) {
    var s = u(c);
    o.width = s, o.height = s;
  }
  return t("div", v([{
    class: i([l, {
      vertical: e.vertical
    }])
  }, d(a, !0)]), [t("span", {
    class: i("spinner", l),
    style: o
  }, [x(t, e)]), S(t, e, r)]);
}
m.props = {
  color: String,
  size: [Number, String],
  vertical: Boolean,
  textSize: [Number, String],
  textColor: String,
  type: {
    type: String,
    default: "circular"
  }
};
var b = y(m);
export { b as default };
